import React from 'react';
import PropTypes from 'prop-types';

const CampaignItem = ({
  pressReleaseUrl,
  siteName,
  siteDomain,
}) => {
  return (
    <div className="campaign-item">
      <div className="campaign-item__site-name">
        {siteName}
      </div>
      <ul className="campaign-item__item-details">
        <li>Dive website placement</li>
        <li>Daily newsletter inclusion</li>
        <li>Press Release feed</li>
      </ul>
      <a className="call-out-link" href={`https://${siteDomain}${pressReleaseUrl}`} target="_blank" rel="noreferrer">
        View on {siteName} <span className="call-out-link__arrow">➔</span>
      </a>
    </div>
  );
};

CampaignItem.propTypes = {
  siteName: PropTypes.string.isRequired,
  siteDomain: PropTypes.string.isRequired,
  pressReleaseUrl: PropTypes.string.isRequired,
};

export default CampaignItem;
